import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import "./HeroView.css";

function HeroView() {
  const handleDemoButtonClick = () => {
    // Navigate to the desired URL in a new tab
    window.open(
      "https://blankwalldemo.myshopify.com/products/coup-de-vent/?arlaunchpad=1",
      "_blank",
    );
  };

  const handleChatButtonClick = () => {
    window.location.href = "/contact";
  };

  return (
    <div className="background-primary">
      <Container maxWidth="xl">
        <Grid container style={{ paddingTop: "1rem" }}>
          <Grid item xs={12} md={6} sx={{ mt: "1em" }} align="center">
            <div className="hero-media-container">
              <img src="painting.png" alt="painting" className="fade-up2"></img>
              <img
                src="touchcursor.png"
                alt="touchicon"
                className="fade-up3"
              ></img>
              <img src="background.png" alt="background"></img>
              <img src="iphone.png" alt="iphone" className="fade-up"></img>
            </div>
          </Grid>
          <Grid item xs={12} md={6} style={{ textAlign: "left" }}>
            <Stack spacing={3} className="hero-content-stack">
              <div className="hero-title">
                Make Every Room Your&nbsp;
                <span className="hero-gradient-text">Showroom</span>
              </div>
              <p className="hero-subtitle">
                Display your art anywhere with augmented reality. Boost customer
                confidence and increase sales.
              </p>
              <span className="hero-button-container">
                <button className="hero-button hero-button-primary" onClick={handleDemoButtonClick}>
                  Try the Demo
                </button>
                <button className="hero-button hero-button-secondary" onClick={handleChatButtonClick}>
                  Let's Chat
                </button>
              </span>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default HeroView;
